var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Rewards Analytics","icon":"gift","css-class":"analytics-rewards","default-label":"Rewards"}},[_c(_setup.RewardsMetrics)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }